import {
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import { schema } from '@snap-types/schemas';
import { z } from 'zod/v4';

const d = schema.t.dec;

export const columns = {
  uuid,
  sortOrder: z.number().int().default(0),
  marketCode: z.string().nonempty('Market code cannot be empty'),
  adjustment: d.fromUnknown.check(d.checks.gt(0)),
  priceSegmentConfigUuid: uuid,

  ...nullableCreatedByUserUuid,
  ...timestamps,

  deletedAt: z.date().nullish(),
};
